import { Component } from '@angular/core';


@Component({
  selector: 'app-leftside',
  templateUrl: './left_sidebar.component.html',
  //styleUrls: ['./app.component.css']
})
export class LeftbarComponent {}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/global/left_sidebar.component.ts